import { Injectable } from '@angular/core';

@Injectable()
export class Globals {
  modalVisivel: boolean = false;
}


// WEBPACK FOOTER //
// ./src/app/components/base/util/globals.ts